import {
  type HttpErrorResponse,
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  filter,
  type Observable,
  switchMap,
  take,
  throwError,
} from 'rxjs';

import { environment } from '../../environments/environment';

import { AuthService } from './auth.service';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<string | null>(null);

export function tokenRefreshInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isApiUrl = req.url.startsWith(environment.apiUrl);

      if (
        error.status === 401 &&
        isApiUrl &&
        !req.url.includes('/login') &&
        !req.url.includes('/refresh')
      ) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          return authService.refreshToken().pipe(
            switchMap((response) => {
              isRefreshing = false;
              refreshTokenSubject.next(response.token);
              const cloned = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${response.token}`),
              });
              return next(cloned);
            }),
            catchError((refreshError) => {
              isRefreshing = false;
              authService.logout();
              return throwError(() => new Error(String(refreshError)));
            }),
          );
        } else {
          return refreshTokenSubject.pipe(
            filter((token) => token !== null),
            take(1),
            switchMap((token) => {
              const cloned = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`),
              });
              return next(cloned);
            }),
          );
        }
      }

      return throwError(() => error);
    }),
  );
}
